import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React from "react";

import PropertyValue from "@/mk2/apps/bazaar/components/PropertyValue";
import { ListItem } from "@/mk2/components/ListItem";
import useEventCallback from "@/mk2/hooks/useEventCallback";

import styles from "./PropertyListItem.mscss";

interface OwnProps {
    className?: string;
    style?: React.CSSProperties;
    property: string;
    value: string | number;
    label: React.ReactNode;
    selected?: boolean;
    hover?: boolean;
    isLast?: boolean;
    count?: number;

    onClick?(property: string, value: string | number);
    onMouseEnter?(property: string, value: string | number);
}

type Props = OwnProps;

const PropertyListItem: React.FunctionComponent<Props> = ({
    className,
    style,
    selected,
    hover,
    property,
    value,
    label,
    count,
    isLast,
    onClick,
    onMouseEnter,
}) => {
    const onClickCallback = useEventCallback(() => {
        if (onClick) {
            onClick(property, value);
        }
    }, [onClick, property, value]);

    const onMouseEnterCallback = useEventCallback(() => {
        if (onMouseEnter) {
            onMouseEnter(property, value);
        }
    }, [onMouseEnter, property, value]);

    return (
        <ListItem
            className={cx(
                styles.PropertyListItem,
                hover && styles["PropertyListItem--hover"],
                className,
            )}
            style={style}
            isLast={isLast}
            onClick={onClickCallback}
            onMouseEnter={onMouseEnterCallback}
            data-cy={`property-${property}-${value}`}
        >
            <div
                className={cx(
                    styles.PropertyListItem__content,
                    selected && styles["PropertyListItem__content--selected"],
                )}
            >
                <span className={styles.PropertyListItem__label}>
                    <PropertyValue property={property} value={value} label={label} />
                    {(count || count === 0) && (
                        <span className={styles.PropertyListItem__count}> ({count})</span>
                    )}
                </span>

                {selected && (
                    <FontAwesomeIcon className={styles.PropertyListItem__check} icon={faCheck} />
                )}
            </div>
        </ListItem>
    );
};

PropertyListItem.displayName = "PropertyListItem";

export default React.memo<Props>(PropertyListItem);
